import React, { Component } from 'react'
import TextAreaElement from 'components/common/ResizeableTextarea'
import HobnobSelect from 'components/common/HobnobSelect'
import HobnobModal from 'src/components/common/HobnobModal'
import Button from 'components/common/Button'
import { sendUpdateEvent } from 'src/actions/event'
import { hideSendUpdateModal } from 'src/actions/frontend'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styles from './send-update.scss'

const sendList = [
  {
    text: 'Attending & undecided',
    value: 1
  },
  {
    text: 'Attending',
    value: 2
  },
  {
    text: 'undecided',
    value: 3
  },
  {
    text: 'Not Attending',
    value: 4
  },
  {
    text: 'All',
    value: 5
  }
]

const sendType = {
  1: ['accepted', 'undecided'],
  2: ['accepted'],
  3: ['undecided'],
  4: ['declined'],
  5: ['accepted', 'undecided', 'declined']
}

class SendUpdate extends Component {
  state = {
    sendCode: 1,
    updateComment: ''
  }

  handleSendUpdate = () => {
    const { onSendUpdate, event } = this.props
    const { updateComment, sendCode } = this.state
    const successActions = [hideSendUpdateModal()]
    onSendUpdate({
      eventId: event.id,
      content: updateComment,
      recipient_states: sendType[sendCode],
      successActions
    })
  }

  render() {
    const { updateComment, sendCode } = this.state
    const { sendUpdateModal, onHideSendUpdateModal } = this.props
    return (
      <HobnobModal
        show={sendUpdateModal}
        onClose={onHideSendUpdateModal}
        title="Send Update"
        closeOnOuterClick={false}
      >
        <div className={styles['send-update-container']}>
          <div className={styles['send-type-wrapper']}>
            <label>To:</label>
            <HobnobSelect
              value={sendCode}
              options={sendList}
              onChange={value => this.setState({ sendCode: value })}
              closeOnOuterClick
            />
          </div>

          <div className={styles['input-wrapper']}>
            <TextAreaElement
              className={styles['textArea-inner']}
              placeholder="Send your guests a custom reminder or let them know about changes to the event.&#13;&#10;Guests without the app will be notified via text or email. Guests with the app will receive a push notification."
              onChangeComment={value => this.setState({ updateComment: value })}
              comment={updateComment}
            />
          </div>

          <div className={styles['button-wrapper']}>
            <Button className={styles['button-inner']} onClick={this.handleSendUpdate}>
              Send
            </Button>
          </div>
        </div>
      </HobnobModal>
    )
  }
}

SendUpdate.propTypes = {
  onSendUpdate: PropTypes.func,
  event: PropTypes.object,
  sendUpdateModal: PropTypes.bool,
  onHideSendUpdateModal: PropTypes.func
}

function mapStateToProps(state) {
  return {
    sendUpdateModal: state.frontend.sendUpdateModal
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onSendUpdate: params => dispatch(sendUpdateEvent(params)),
    onHideSendUpdateModal: () => dispatch(hideSendUpdateModal())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SendUpdate)



// WEBPACK FOOTER //
// ./src/components/details/HostOption/SendUpdate/SendUpdate.jsx